import { render } from "./EventList.vue?vue&type=template&id=08d868f4&scoped=true"
import script from "./EventList.vue?vue&type=script&lang=js"
export * from "./EventList.vue?vue&type=script&lang=js"

import "./EventList.vue?vue&type=style&index=0&id=08d868f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d868f4"],['__file',"src/containers/widget/components/EventList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08d868f4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08d868f4', __exports__)) {
    api.reload('08d868f4', __exports__)
  }
  
  module.hot.accept("./EventList.vue?vue&type=template&id=08d868f4&scoped=true", () => {
    api.rerender('08d868f4', render)
  })

}


export default __exports__